import React, { useContext, useEffect, useState, useCallback, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import useToggle from '../../Hooks/useToggle';
import axios from 'axios';
import useMediaQuery from '../../Hooks/useMediaQuery';
import { useQueryParams } from '../../Hooks/useQueryParams';
import useOnceEffect from '../../Hooks/useOnceEffect';

const ChatContext = React.createContext()

const ChatPage = () => {

    const [chat, setChat] = useState(null)
    const messages = useRef([])

    const refactorData = useCallback((mensajes = []) => {

        let _aux = mensajes?.map((elm, i) => {
            return {
                dateTime : elm.fechaCreacion,
                message: elm.message,
                userReceiverId: elm?.userReceiver?.userId,
                userSendingId: elm?.userSender?.userId,
                userReceive: elm?.userReceiver,
                userSend: elm?.userSender
            }
        })

        setChat(_old => ({
            ..._old,
            messages: _aux
        }))

    }, [setChat])

    useEffect(() => {

        

        function getChats() {
            
            axios.get("message/list-message")
            .then(data => {

                if(messages.current.length === 0) {

                    messages.current = data.data
                    refactorData(data.data)
                    return;
                }
                    

                if(messages.current.length !== data.data?.length) {

                    messages.current = data.data
                    refactorData(data.data)
                    return;
                }
            })
        }

        getChats();

        const interval = setInterval(getChats, 1000 * 10)


        return () => {
            clearInterval(interval)
        }

    }, [refactorData])
    return (
        <ChatContext.Provider value={[chat, setChat]}>
            <main style={{height: "125vh"}} className="container py-5">
                <ChatNav />
                <ChatBody />
            </main>
        </ChatContext.Provider>
        
    );
};


const ChatNav = () => {

    const [chat, setChat] = useContext(ChatContext)
    const [modal, toggleModal, setToggle] = useToggle(false)
    const [users, setUsers] = useState([])

    const queryParams = useQueryParams({
        create: 0
    })

    const [message, setMessage] = useState({
        messageId: 0,
        userReceiverId: queryParams.create,
        message: ""
    })

    function getUsers() {

        if(users.length > 0)
            return

        axios.get("message/list-user-new-message")
            .then( res => {
                let users = res.data

                setUsers(users.sort((a,b) => {
                    return (a.username > b.username) ? 1 : 0
                }))
            })
    }

    function sendNewMessage(e) {
        e.preventDefault()

        toggleModal()
        let userReceiver = users.find(elm => parseInt(elm.userId) === parseInt(message.userReceiverId))


        axios.post("message/create-message", message)
        .then(() => {

            message.userReceiverId = parseInt(message.userReceiverId)
            message.userSendingId = parseInt(localStorage.getItem("userId"))
            message.fechaCreacion = (new Date()).toLocaleString()
            message.userReceive   = userReceiver

            if(chat === null) {



                setChat({
                    currentReceiver: message.userReceiverId,
                    currentUser: userReceiver,
                    messages: ([].push(message))
                })

                return
            }

            let _chat = {}
            let { messages } = {...chat}

            _chat.currentUser     = userReceiver
            _chat.currentReceiver = message.userReceiverId
            _chat.messages        = [message,...messages ]
            
            setChat({..._chat})
        })

        .catch(() => console.error("No se puede enviar el mensaje"))
    }

    useOnceEffect(() => {

        if(parseInt(queryParams.create) !== 0) {
            setToggle(true)
        }
    })

    return (

        <>
            <div className='row'>
                <div className='col-4'>
                    Mensajes
                </div>
                <div className='col-5'>
                </div>
                <div className='col-3'>
                    <button className='btn-deg' onClick={toggleModal}>Nuevo Mensaje</button>
                </div>
            </div>

            <Modal onEnter={getUsers} show={modal} onHide={toggleModal} keyboard={false} >
                <Modal.Body>
                    <form className='container' onSubmit={sendNewMessage}>
                        <h2 className='mb-3'>Nuevo Mensaje</h2>
                        <div className='form-group mb-3'>
                            <select value={message.userReceiverId} className='form-control' onChange={({target}) => setMessage({...message, userReceiverId: parseInt(target.value) })}required>
                                <option hidden>Agrega un usuario</option>
                                { users.map((elm, i) => (

                                    <option key={i} value={elm.userId}>{elm.username} {elm.name ? ("- " + elm.name) : ""}</option>
                                ))}
                            </select>
                        </div>


                        <div className="form-group mb-3">
                            <textarea placeholder="&#9998; Escribir Mensaje" className='form-control' value={message.message} onChange={({target}) => setMessage({...message, message: target.value})} required />
                        </div>

                        <button className='btn-deg mb-3'>Enviar Mensaje</button>
                    </form>
                </Modal.Body>
            </Modal>

        </>
    );
}

const ChatBody = () => {

    const [chat] = useContext(ChatContext)
    const isMobile = useMediaQuery("(max-width: 578px)");

    return (
        <section className='row mt-5 '>

            { (isMobile && chat?.currentUser) &&
                <ChatRight />
            }

            { (isMobile && !chat?.currentUser) &&
                <ChatLeft />
            }

            { !isMobile &&
                <>
                    <div className='col-4'>
                        <ChatLeft />
                    </div>

                    <div className='col-8'>
                        <ChatRight />
                    </div>
                </>
            }
            

        </section>
    );
}

const ChatLeft = () => {


    const [chat, setChat] = useContext(ChatContext)

    const refactorMessages = () => {
        
        if(chat === null)
            return [ [], [] ]

        const { 
            messages  = []
        } = chat
        const user_id = parseInt(localStorage.getItem("userId"))

        let people_name    = []
        let people_contact = []


        messages.forEach(message => {

            let user = {}

            if(parseInt(message.userSendingId) === user_id) {
                user = message.userReceive
            }else {
                user = message.userSend
            }

            
            if(!people_name.includes(user.email)) {
                people_name.push(user.email)
                people_contact[user.email] = user
            }

        });


        return [people_name, people_contact]
    }

    function selectCurrentUser(user)    {
        setChat({
            ...chat,
            currentUser: user,
            currentReceiver: user.userId
        })
    }

    const ChatAvailable = () => {

        const [people_name, people_contact] = refactorMessages()

        return people_name.map((elm, i) => (
            <ChatName key={i} name={people_contact[elm]["username"]} onClick={() => selectCurrentUser(people_contact[elm])} />
        ))
    }

    return (
        <div className='card' style={{height: "100vh", overflowY: "auto", borderRadius: "2rem"}}>
            <div className='card-body'>
                <ul type="button" className="list-group list-group-flush">
                    {ChatAvailable()}
                </ul>
            </div>
        </div>
    );
}

const ChatName = ({name = "", onClick}) => {
    return (
        <li onClick={onClick} className='list-group-item chat d-flex align-items-center mb-3'>
            <ChatAvatar name={name} />&nbsp;&nbsp; {name}
        </li>
    )
}

const ChatAvatar = ({name = ""}) => {

    return (
        <div className='avatar-custom mr-5' >
            {name.split("")[0]?.toUpperCase()}
        </div>
    )
}

const ChatRight = () => {

    const [chat] = useContext(ChatContext)

    return (
        <>
            <div className='card' style={{height: "100vh", borderRadius: "2rem"}}>
                <div className='card-body'>

                    { (chat?.currentUser)
                        ? <>
                            <ChatRightHeader name={chat.currentUser.username} />
                            <ChatRightBody />
                            <ChatRightFooter />
                          </>

                        : <h1 className="text-center mt-3">Seleccione una conversación</h1>
                    }
                    
                </div>
            </div>
        </>
    )
}

const ChatRightHeader = ({name = ""}) => {

    const [chat, setChat] = useContext(ChatContext)

    function closeCurrentUser() {
        setChat({
            ...chat,
            currentUser: undefined
        })
    }

    return (
        <>
            <section style={{height: "5vh", borderBottom: "1px solid grey"}} className="d-flex justify-content-between mb-1">
                <div>
                    <span type="button" onClick={closeCurrentUser} >&#10005;</span> &nbsp; <b>{name?.toUpperCase()}</b>
                </div>
            </section>
        </>
    );
}

const ChatRightBody = () => {

    const userId = parseInt(localStorage.getItem("userId"))
    const [chat] = useContext(ChatContext)
    const {
        messages = [] 
    } = chat

    /**
     * 
     * @param {*} _messages 
     * @returns {array}
     */
    function orderMessageByDate(_messages = []) {

        let userMessages = messages.filter(elm => (
            elm.userReceiverId === chat.currentReceiver ||
            elm.userSendingId  === chat.currentReceiver
        ))

        return userMessages.sort((a, b) => {

            let date_a = (new Date(a.fechaCreacion)).getTime()
            let date_b = (new Date(b.fechaCreacion)).getTime()


            return date_a - date_b
        })

        

    }

    return (
        <section style={{height: "70vh", overflowY: "auto"}}>
            
            {orderMessageByDate().reverse().map((elm, i) => {

                    let isMine = elm.userSendingId === userId

                    return (
                        <div key={i} className={'chat-message d-flex ' + (isMine ? "justify-content-end mine" : "")}>
                            <div>
                                {elm.message}
                            </div>
                        </div>
                    );
                })
            }

        </section>
    );
}

const ChatRightFooter = () => {

    const [message, setMessage] = useState("")
    const [chat, setChat] = useContext(ChatContext)


    function sendMessage(e) {
        e.preventDefault()

        setMessage("");

        const sendMessage = {
            messageId: 0,
            userReceiverId: chat.currentReceiver,
            message: message
        }

        axios.post("message/create-message", sendMessage)
        .then(() => {

            sendMessage.userSendingId = parseInt(localStorage.getItem("userId"))
            sendMessage.fechaCreacion = (new Date()).toISOString()
            sendMessage.userReceive   = chat.currentUser

            let { messages } = {...chat}
            messages = [sendMessage, ...messages]
            
            setChat({
                ...chat,
                messages: messages
            })
        })

        .catch(() => console.warn("No se puede enviar el mensaje"))
    }

    return (
        <section style={{height: "10vh"}}>
            <hr />

            <div className='form-group'>
                <textarea rows={1} placeholder="&#9998; Escribir Mensaje" className='form-control' value={message} onChange={({target}) => setMessage(target.value)} />
            </div>

            <div className='d-flex justify-content-end mb-2 mt-2'>
                <button className='btn-deg' style={{width: "15rem"}} onClick={sendMessage}>Enviar</button>
            </div>
        </section>
    );
}

export default ChatPage;